// mulberry32, kept as a plain number in the state so that a State is still just data (rule 3).

export interface Draw {
  /** in [0, 1) */
  value: number;
  /** the RNG state after this draw */
  seed: number;
}

export function nextRandom(seed: number): Draw {
  const next = (seed + 0x6d2b79f5) >>> 0;
  let t = next;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return { value: ((t ^ (t >>> 14)) >>> 0) / 4294967296, seed: next };
}

/** Draws a float in [0, 1) and advances the RNG in place. Only ever call this on a step draft. */
export function drawFloat(state: { rng: number }): number {
  const draw = nextRandom(state.rng);
  state.rng = draw.seed;
  return draw.value;
}

/** Integer in [0, n). */
export function drawInt(state: { rng: number }, n: number): number {
  return Math.floor(drawFloat(state) * n);
}

/** Float in [min, max). */
export function drawRange(state: { rng: number }, min: number, max: number): number {
  return min + drawFloat(state) * (max - min);
}

/**
 * A float in [0, 1) derived from an RNG state and a salt without advancing the RNG: for choices that
 * must be a pure function of the state and may be asked for several times a tick (the bots).
 */
export function hashRandom(seed: number, salt: number): number {
  return nextRandom((seed ^ Math.imul(salt + 1, 0x9e3779b1)) >>> 0).value;
}
